























import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { groupBy, map, orderBy } from 'lodash';

import { Match, ScoreType } from '../../schedule/store/models';
import { Actions as ScheduleActions } from '@/modules/schedule/store/actions';
import { scheduleModuleName } from '@/modules/schedule/store';
const scheduleModule = namespace(scheduleModuleName);

@Component({
  components: {
  },
})
export default class MatchList extends Vue {

  @Prop() private matches!: Match[];

  @scheduleModule.Action(ScheduleActions.DELETE_MATCH) private deleteMatch!: (match: Match) => void;

  private editMatchClicked(matchId: number, matchDayId: number) {
    this.$emit('editMatchClicked', matchId, matchDayId );
    setTimeout(this.showModal.bind(this), 200);
  }

  private deleteMatchClicked(match: Match) {

    (this as any).$bvModal.msgBoxConfirm(
      `Czy na pewno chcesz usunąć spotkanie meczowe ${match.teamHomeName} vs. ${match.teamAwayName}
        z ${this.$moment(match.matchDateTime).format('YYYY-MM-DD HH:mm')}.`, {
      title: 'Potwierdź usunięcie',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'danger',
      okTitle: 'Usuń',
      cancelTitle: 'Anuluj',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true,
    })
    .then((confirmed: boolean) => {
      if (confirmed) {
        this.deleteMatch(match);
      }
    });
  }

  private showModal() {
    (((this as any).$bvModal) as any).show(`editMatchModal`);
  }

  private matchesGroupedByDate() {

    const orderedMatches = orderBy(this.matches, (m) => m.matchDateTime, 'asc');
    const groups = groupBy(orderedMatches, (match) => this.$moment(match.matchDateTime).format('dddd, DD.MM'));

    return map(groups, (group, date) => ({ date, matches: group}) );
  }

  private determineIfDisplayHourOrScore(match: Match) {
      if (this.scoreIsProvided(match)) {
        return `${match.homeTeamScore}:${match.awayTeamScore}`;
      }
      return this.$moment(match.matchDateTime).format('HH:mm');
  }

  private scoreIsProvided(match: Match) {
    return match.scoreType !== ScoreType.NoScore ||
        (match.homeTeamScore !== null && match.awayTeamScore !== null);
  }
}
